import { Badge } from "@/components/ui/badge";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { BarChart3, Clock, DollarSign, MapPin, Package } from "lucide-react";
import ReceiverAnalytics from "./ReceiverAnalytics";
import { ReceiverAnalyticsLoads } from "./ReceiverAnalyticsLoads";
import { useState } from "react";

export function ReceiverView() {
  const [weeksToShow, setWeeksToShow] = useState(4);
  return (
    <div className="flex flex-col items-center justify-center space-y-4 p-4">
      <ReceiverAnalytics setWeeksToShow={setWeeksToShow} />
    </div>
  );
}
